import { INTELLIGENT_PHOTO_CAPTURE_ADD_ESTIMATED_SUMMARY_FILE_INFO, INTELLIGENT_PHOTO_CAPTURE_CLEAR_ESTIMATED_SUMMARY_FILES_INFO } from '../actions';
export const photoCaptureIntelligentEstimatedSummaryFilesInfoReducer = (state, action) => {
    var _a;
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_ADD_ESTIMATED_SUMMARY_FILE_INFO:
            return Object.assign(Object.assign({}, state), { estimatedSummaryFilesInfo: [...((_a = state.estimatedSummaryFilesInfo) !== null && _a !== void 0 ? _a : []), action.payload.fileInfo] });
        case INTELLIGENT_PHOTO_CAPTURE_CLEAR_ESTIMATED_SUMMARY_FILES_INFO:
            return Object.assign(Object.assign({}, state), { estimatedSummaryFilesInfo: [] });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureEstimatedSummaryFileInfoReducer.js.map